import React from 'react';
import { useTranslation } from 'react-i18next';
import { setCareerLanguage, SUPPORTED_LANGS } from './index';

const LANG_META = {
    en: { flag: '🇬🇧', code: 'EN', label: 'English' },
    es: { flag: '🇪🇸', code: 'ES', label: 'Español' },
    pt: { flag: '🇧🇷', code: 'PT', label: 'Português' },
};

// Selector de idioma del Modo Carrera. Grupo de pills (bandera + código) al estilo de los
// otros chips del header; el cambio es instantáneo (i18next re-renderiza todo lo que usa useTranslation).
export default function LanguageSelector({ className = '' }) {
    const { i18n } = useTranslation('career');
    const current = SUPPORTED_LANGS.includes(i18n.language) ? i18n.language : 'en';
    return (
        <div
            className={`cs-lang-group ${className}`}
            role="group"
            aria-label="Language / Idioma / Idioma"
        >
            {SUPPORTED_LANGS.map((l) => (
                <button
                    key={l}
                    type="button"
                    className={`cs-lang-btn${l === current ? ' cs-lang-btn--active' : ''}`}
                    onClick={() => setCareerLanguage(l)}
                    title={LANG_META[l].label}
                    aria-pressed={l === current}
                >
                    <span className="cs-lang-flag" aria-hidden="true">{LANG_META[l].flag}</span>
                    <span className="cs-lang-code">{LANG_META[l].code}</span>
                </button>
            ))}
        </div>
    );
}
